import React from "react";
import CommonHeader from "../../../student_module/components/navbars/CommonHeader";
import BrandLogo from "../../../student_module/components/navbars/BrandLogo";
import "./_navbar.scss";

/**
 * Header for the neetjee-guru settings pages: the shared student header
 * (its own colour). These pages use the guru login, not the student one, so
 * the student user menu is hidden.
 *
 * Props: onClick (sidebar toggle).
 */
function NavbarOne({ onClick }) {
  return (
    <CommonHeader
      color="auto"
      tone="light"
      showUserMenu={false}
      onToggleSidebar={onClick}
      left={<BrandLogo fill="#ffffff" />}
    />
  );
}

export default NavbarOne;
